import React from 'react';
import cx from 'classnames';

import { MDText } from 'i18n-react';

import FAQSection from '../../../contentPages/landingPages/FAQSection/FAQSection';
import LocalTexts from '../../CustomerHubTexts.json';

import styles from './TrackerFAQ.scss';

const LocalT = new MDText(LocalTexts);

const TrackerFAQ = ({ faq = [], title = null }) => {
  if (!Array.isArray(faq) || !faq.length) {
    return <p className={styles.error}>{LocalT.translate('faq.errorMessage')}</p>;
  }

  const className = cx(styles.component);

  return (
    <FAQSection {...{ className, faq, title }} />
  );
};

export default TrackerFAQ;
